'use client';

import { createContext } from 'react';

export const FeatureFlagContext = createContext<any>({});

export const FeatureFlagContextProvider = ({ children, data }) => {
  return <FeatureFlagContext.Provider value={data}>{children}</FeatureFlagContext.Provider>;
}
